import { store } from '../../app/store';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { selectSessionId } from '../../app/slices/session.slice';
import sessionService from '../../services/session.service';
import { CallbackEvent } from '../../types/sdk';

export class SDKCallbacks {
	private readonly callbacks: Record<CallbackEvent, (data?: any) => Promise<void>>;

	constructor() {
		this.callbacks = {
			onLoad: createCallback('onLoad'),
			onReady: createCallback('onReady'),
			onAbort: createCallback('onAbort'),
			onClose: createCallback('onClose'),
			onError: createCallback('onError'),
			onFinished: createCallback('onFinished')
		};

		this.execute = this.execute.bind(this);
	}

	async execute(event: CallbackEvent, data?: any) {
		const callback = this.callbacks[event];
		return await callback(data);
	}
}

export const sdkCallbacks = new SDKCallbacks();

function createCallback(event: CallbackEvent) {
	let executed = false;

	return async (data: any) => {
		if (executed) return;

		const sessionId = getSessionId(store);
		if (!sessionId) throw new Error(`Session id not defined for ${event} callback`);

		executed = true;
		await sessionService.logEvent(sessionId, event, data);
	};
}

function getSessionId(store: ToolkitStore) {
	const state = store.getState();
	return selectSessionId(state);
}
